import { faStickyNote } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CardActions, Collapse, Grid, Typography, useTheme } from "@mui/material";
import { format } from "date-fns/format";
import React, { useState } from "react";
import ActionMenu from "../action-menu/ActionMenu";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";
import { IObjectHistoryMemoItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";
import { IeLynxObject } from "../../common/models/eLynxObject";
import AttachmentList, { AttachmentListCardActionEnum } from "../attachment-list/AttachmentList";
import { ExpandMore } from "@mui/icons-material";
import { IAttachment } from "../../common/models/IAttachment";

export type ObjectHistoryMemoItemProps = {
    item: IObjectHistoryMemoItem;
    contextObject?: IeLynxObject;
    readOnly?: boolean;
    onAction: (action: ObjectHistoryMemoItemActionEnum, item: IObjectHistoryMemoItem) => void;
    onAttachmentAction: (action: AttachmentListCardActionEnum, item: IAttachment) => void;
};

export enum ObjectHistoryMemoItemActionEnum {
    Edit = 1,
    Delete = 2
}

export function ObjectHistoryMemoItem({ 
    item,
    contextObject, 
    onAction, 
    onAttachmentAction,
    readOnly }: ObjectHistoryMemoItemProps) {

    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();

    

    const actionItems = readOnly ?
        [] :
        new Array<ActionMenuItem>(
        {
            label: "Edit",
            onClick: () => {
                onAction && onAction(ObjectHistoryMemoItemActionEnum.Edit, item);
            }
        },
        {
            label: "Delete",
            onClick: () => {
                onAction && onAction(ObjectHistoryMemoItemActionEnum.Delete, item);
            }
        }
    );

    return (
        <ObjectHistoryCard itemID={item.memoID}>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<FontAwesomeIcon icon={faStickyNote} size="2x" />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.userName}
                        contextObject={contextObject}
                    />
                }
                action={<ActionMenu actionItems={actionItems} />}
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                <Typography variant="body2" noWrap={false}>
                    {item.text}
                </Typography>





            {item.attachments.length > 0 && <CardActions disableSpacing>
                <Button
                    sx={{
                        color: "text.primary"
                    }}
                    variant="text"
                    onClick={() => setExpanded(!expanded)}
                    style={{ marginLeft: "auto" }}
                    endIcon={<ExpandMore sx={{
                        transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shortest,
                        })
                    }} />}
                >
                    Attachments
                </Button>
            </CardActions>
            }
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <Grid container spacing={2}>

                        {item.attachments.length > 0 &&
                            <Grid size={12}>
                                {/* <Typography variant="body1" sx={{ marginBottom: 1 }}>Attachments</Typography> */}
                                <AttachmentList attachments={item.attachments} onAction={onAttachmentAction} />
                            </Grid>
                        }
                    </Grid>
            </Collapse>









            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}

